export const defaultTableOptions = {
  sortIndicator: true,
  hideSizePerPage: true,
  sizePerPage: 10,
  sizePerPageList: [10, 20, 30, 50, 100],
  paginationSize: 3,
  noDataText: 'Não existem dados para exibição.',
  firstPageTitle: 'Ir para primeira página',
  lastPageTitle: 'Ir para última página',
  lastPageText: 'Última página',
  nextPageTitle: 'Próxima página',
  prePageTitle: 'Página anterior',
  paginationShowsTotal: (start, to, total) => `Exibindo de ${start} até ${to} de um total de ${total}.`,
  hidePageListOnlyOnePage: true,
  clearSearch: true,
  alwaysShowAllBtns: false,
  withFirstAndLast: false,
};
